<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header disable-icon-rotate>
              Первые действия при ДТП
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="purple lighten-2"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="purple lighten-2">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light">
                        Действие 1
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          Включите аварийную сигнализацию
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="amber lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="amber lighten-1 justify-end">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light">
                        Действие 2
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          Установите знак аварийной остановки (не менее 15 м от транспортного средства в городе и 30 м - вне города)
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="cyan lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="cyan lighten-1">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light">
                        Действие 3
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          При наличии пострадавших вызвать экстренные службы по номеру 112
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header disable-icon-rotate>
              Когда необходимо вызывать сотрудников ГИБДД
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="red lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="red lighten-1 justify-end">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light" />
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          В результате ДТП повреждены более двух автомобилей
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="green lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="green lighten-1">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light" />
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          В результате ДТП имеются пострадавшие (раненые, погибшие)
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="cyan lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="cyan lighten-1">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light" />
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          У участников ДТП отсутствуют действующие страховые полисы ОСАГО
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="purple lighten-1"
                  fill-dot
                  left
                >
                  <v-card>
                    <v-card-title class="purple lighten-1">
                      <v-icon
                        dark
                        size="42"
                        class="mr-4"
                      >
                        mdi-magnify
                      </v-icon>
                      <h2 class="display-1 white--text font-weight-light" />
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          Участники ДТП имеют разногласия при установлении виновности сторон
                        </v-col>
                        <v-col
                          class="hidden-sm-and-down text-right"
                          md="2"
                        >
                          <v-icon size="64">
                            mdi-calendar-text
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <v-btn
          min-width="150"
          color="primary"
          @click="$router.push('/accident/create/short')"
        >
          Оформление ДТП
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Main',

    data () {
      return {
      }
    },
  }
</script>
